import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/snippets/poshmark-offer-to-likers';

export default function Example() {
  return (
    <>
      <Head>
        <title>Everything about Offers to Likers | OneShop Blog</title>
        <meta name='description' content='Master offers to likers in Poshmark to boost your sales!' />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-offer-to-likers' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-offer-to-likers' />
        <meta property='og:title' content='Everything about Offers to Likers | OneShop Blog' />
        <meta property='og:description' content='Master offers to likers in Poshmark to boost your sales!' />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-07-11T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-07-11T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
